import { render, staticRenderFns } from "./CtcWidgetResults.vue?vue&type=template&id=40e05287&scoped=true&"
import script from "./CtcWidgetResults.vue?vue&type=script&lang=js&"
export * from "./CtcWidgetResults.vue?vue&type=script&lang=js&"
import style0 from "./CtcWidgetResults.vue?vue&type=style&index=0&id=40e05287&lang=scss&scoped=true&"
import style1 from "./CtcWidgetResults.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e05287",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VMenu})
